import { ObservableFromFetch } from "../ObservableFromFetch"
import { IVRCallLogRequest } from "./Model/IVRCallLogRequest"
import { IVRLog } from "./Model/IVRLog"

export function IVRCallLogObservable(request: IVRCallLogRequest) {
  const requestBody: string = JSON.stringify(request)

  return ObservableFromFetch<IVRLog[]>("GovDonor/GetIVRCallLog", requestBody)
}
